import { Checkbox, DatePicker, Pagination, Popover } from "antd";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-number-input";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { parsePhoneNumber } from "react-phone-number-input";
import moment from "moment/moment";
import axios from "axios";
import CheckBranch from "../branchModal";

const CompanyBranch = ({ search, setSearch }) => {
  const QuotationFlow = useSelector((state) => state.QuotationFlow);
  const PlaceOrderCheck = useSelector((state) => state.PlaceOrderCheck);
  const router = useNavigate();
  const dispatch = useDispatch();
  const dataUser = useSelector((state) => state.dataUser);
  const [vendors, setVendors] = useState([]);
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [show, setShow] = useState("");
  const [dob, setDob] = useState("");
  const [prompt, setPrompt] = useState("");
  const [countryCode, setCountryCode] = useState(null);
  const [phoneNoo, setPhoneNoo] = useState(null);
  const [searchDob, setSearchDob] = useState("");
  const [pagewithsearch, setPagewithsearch] = useState(1);

  const [cancelTokenSource, setCancelTokenSource] = useState(null);
  const [status, setStatus] = useState(false);
  const [showCheckBranchModal, setShowCheckBranchModal] = useState(false);
  const [company, setCompany] = useState("");

  useEffect(() => {
    const delay = 500;

    const timeoutId = setTimeout(() => {
      // Cancel the previous request if it exists
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }

      // Create a new cancel token source for this request
      const newCancelTokenSource = axios.CancelToken.source();
      setCancelTokenSource(newCancelTokenSource);

      const params = {
        limit: 8,
        skip: (page - 1) * 8,
        sortBy: "createdAt:desc",
        page: page,

        // limit: 6,
        // skip:
        //   search || searchDob || countryCode || phoneNoo ? 0 : (page - 1) * 6,
        // page: search ? pagewithsearch : page, // Separate page for search and non-search scenarios
        // sortBy: "createdAt:desc",
        // ...(search && { search }),
        // ...(searchDob && { dateOfBirth: searchDob }),
        // ...(countryCode &&
        //   phoneNoo && { countryCode: `+${countryCode}`, phoneNo: phoneNoo }),
        // ...(status && { status: "ceased" }),
      };

      fetchEmployees(params, newCancelTokenSource);
    }, delay);

    return () => {
      clearTimeout(timeoutId);

      // Cancel the request if the component is unmounted
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }
    };
  }, [page, searchDob, countryCode, phoneNoo, pagewithsearch, status]);

  const fetchEmployees = (params, cancelTokenSource) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/v1/vendor-branch/own`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
        cancelToken: cancelTokenSource.token,
      })
      .then((data) => {
        setVendors(data?.data?.rows);
        setTotalPages(data?.data?.totalPages);
        setShow(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const pageHandler = (e) => {
    if (search) {
      // If searching, update searchPage
      setPagewithsearch(e);
    } else {
      // If not searching, update page
      setPage(e);
    }
  };

  //   // get Company
  useEffect(() => {
    if (user === "vendor-owner") {
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/v1/vendor-company/own`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((data) => {
          setCompany(data?.data);
        })
        .catch(() => {});
    }
  }, []);

  return (
    <section className="p-2">
      <div className="flex justify-end mt-4 gap-3 mb-3">
        <div className="flex items-center bg-[#f9fbfb] border border-gray-300 rounded-md px-4 py-2 w-[300px] shadow-sm">
          <input
            type="text"
            placeholder="Search Branch"
            className="bg-transparent focus:outline-none text-gray-500 placeholder-gray-400 flex-grow"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-[#1BA397]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.8"
              d="M11 19a8 8 0 100-16 8 8 0 000 16zm5-1l5 5"
            />
          </svg>
        </div>
      </div>

      <div className="mx-auto max-w-screen-xl">
        <div className="bg-white  relative shadow-md sm:rounded-lg overflow-hidden border-2 border-gray-50 ">
          <>
            <div
              className={`grid  gap-8 sm:p-6 p-4  py-4 cursor-pointer  sm:grid-cols-3  grid-cols-1
                `}
            >
              <div
                class="flex items-center p-4 bg-gray-100 rounded-lg shadow-md max-w-sm"
                onClick={() => {
                  dispatch({
                    type: "SELECTED_COMPANY_VENDOR",
                    num: null,
                  });
                  if (QuotationFlow) {
                    router("/Inventory/Quotations");
                    return;
                  }

                  router("/Inventory-Vendor-Orders");
                }}
              >
                <div className="w-[4rem] h-[4rem] mb-4 overflow-hidden rounded-full">
                  <img
                    src={
                      company?.logo
                        ? company?.logo
                        : "data:image/png;base64,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"
                    }
                    alt={""}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div class="ml-4">
                  <h3 class="text-lg font-semibold text-gray-700">
                    {company?.name}
                  </h3>
                  <p class="text-primary font-[500]">
                    {" "}
                    {company?.vendoraddresses?.filter(
                      (addr) => addr?.isCurrent
                    )?.[0] ? (
                      <>
                        {company?.vendoraddresses.filter(
                          (addr) => addr?.isCurrent
                        )[0].city || "----"}
                        <p>
                          {company?.vendoraddresses.filter(
                            (addr) => addr?.isCurrent
                          )[0].regionNo || ""}
                        </p>
                      </>
                    ) : (
                      "----"
                    )}
                  </p>
                </div>
              </div>
              {vendors?.map((pen, index) => (
                <>
                  <div
                    class="flex items-center p-4 bg-gray-100 rounded-lg shadow-md max-w-sm"
                    onClick={() => {
                      dispatch({
                        type: "SELECTED_COMPANY_VENDOR",
                        num: pen,
                      });
                      if (QuotationFlow) {
                        router("/Inventory/Quotations");
                        return;
                      }

                      router("/Inventory-Vendor-Orders");
                    }}
                  >
                    <div className="w-[4rem] h-[4rem] mb-4 overflow-hidden rounded-full">
                      <img
                        src={
                          pen?.logo
                            ? pen?.logo
                            : "data:image/png;base64,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"
                        }
                        alt={""}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div class="ml-4">
                      <h3 class="text-lg font-semibold text-gray-700">
                        {pen?.name}
                      </h3>
                      <p class="text-primary font-[500]">
                        {" "}
                        {pen?.vendoraddresses?.filter(
                          (addr) => addr?.isCurrent
                        )?.[0] ? (
                          <>
                            {pen.vendoraddresses.filter(
                              (addr) => addr?.isCurrent
                            )[0].city || "----"}
                            <p>
                              {pen.vendoraddresses.filter(
                                (addr) => addr?.isCurrent
                              )[0].regionNo || ""}
                            </p>
                          </>
                        ) : (
                          "----"
                        )}
                      </p>
                    </div>
                  </div>
                </>

               
              ))}
            </div>
            <nav
              className="flex flex-col md:flex-row justify-center items-start md:items-center space-y-3 md:space-y-0 p-4"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-gray-500 ">
                Showing{" "}
                <span className="font-semibold text-gray-900">
                  Page {page}{" "}
                </span>
                of{" "}
                <span className="font-semibold text-gray-900">
                  {totalPages}
                </span>
              </span>
              <div className={`flex justify-end mt-7`}>
                <Pagination
                  defaultCurrent={1}
                  total={totalPages * 10}
                  showSizeChanger={false}
                  onChange={pageHandler}
                  current={search ? pagewithsearch : page}
                />
              </div>
            </nav>
          </>
        </div>
      </div>

      {showCheckBranchModal && (
        <CheckBranch setShow={setShowCheckBranchModal} />
      )}
    </section>
  );
};

export default CompanyBranch;
